import React, { Fragment } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { nanoid } from 'nanoid'
import moment from 'moment'
import PropTypes from 'prop-types'
import { withTranslation, useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from '../../../common/helpers'

import { Wrapper as PopoverWrapper, Item as PopoverItem } from './PopoverPresentational'
import PopoverMenu from './PopoverMenu'
import { Link } from '../Link'

import { fetchNews, readNews } from '../../../common/app/actions'
import { Col, Gap, Icon, Row, T, Text } from '..'
import { addIoListener } from '../../io'
import { showPopup } from '../../../common/popups/actions'
import { appTypeConfig } from '../../../common/config'
import { fetchCreditBalance } from '../../../common/orders/actions'
import Loading from '../Loading'

const Positioner = styled.div`
  position: relative;
  align-self: center;
  align-self: flex-end;
  background-color: red;
`

const Wrapper = styled(PopoverWrapper)`
  max-width: 40rem;
  top: 0.3rem;
  // left: auto;
  // right: 0;
`

const Content = styled.div`
  padding: 1.6rem;
`

const rotateKeyframes = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledIcon = styled(Icon)`
  color: ${p => appTypeConfig.headerIconsColor || p.theme.colors.navbarIcons};
  cursor: pointer;

  transition: 0.3s;

  // ${({ rotateAnimation }) =>
    rotateAnimation &&
    css`
      //   animation: ${rotateKeyframes} 0.5s linear infinite;
      //
    `}
`

const RefreshButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  padding-left: 0.5rem;
  margin: 0;
  padding-top: 0.1rem;

  ${StyledIcon} {
    margin-top: -0.1rem;
  }
  &:hover ${StyledIcon} {
    color: ${p => p.theme.colors.primary};
  }
`

const RefreshButtonContent = styled.div`
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const PopupWrapper = ({ children }) => (
  <Positioner>
    <Wrapper>{children}</Wrapper>
  </Positioner>
)

class WalletPopoverMenu extends React.Component {
  nodeId = `wallet-popover-${nanoid()}`

  refreshTimeout = null

  componentDidMount() {
    const { fetchCreditBalance } = this.props
    fetchCreditBalance()
  }

  renderContent = () => {
    const { creditBalance, creditCurrency, fetchCreditBalance, isCreditBalanceLoading } = this.props

    return (
      <Content>
        <Col.Modern alignItems="center">
          <Text noWrap>
            <T>omega; wallet - Credit Balance</T>
          </Text>
          <Gap gap="0.8rem" />
          <Row.Modern alignItems="center">
            <Text noWrap bold big>
              {parseInt(creditBalance || 0, 10).toLocaleString()} {creditCurrency}
            </Text>
            <RefreshButton onClick={() => fetchCreditBalance()} disabled={isCreditBalanceLoading}>
              <RefreshButtonContent>
                {isCreditBalanceLoading && (
                  <Loading type="smallPuff" size={12} width={12} height={12} margin={0} />
                )}
                {!isCreditBalanceLoading && (
                  <StyledIcon
                    name="IosRefresh"
                    rotateAnimation={isCreditBalanceLoading}
                    style={
                      {
                        // marginLeft: '0.5rem',
                      }
                    }
                    size={18}
                  />
                )}
              </RefreshButtonContent>
            </RefreshButton>
          </Row.Modern>
        </Col.Modern>
      </Content>
    )
  }

  render() {
    const { renderLinkComponent, isToRight, fetchCreditBalance, isCreditBalanceLoading } =
      this.props

    return (
      <PopoverMenu
        closeOnOutsideClick
        closeOnEsc
        nodeId={this.nodeId}
        WrapperComponent={PopupWrapper}
        renderContent={this.renderContent}
        animationVariant="big"
        animationOrigin={isToRight ? 'left top' : 'right top'}
      >
        {({ open, isOpen, close }) => (
          <div
            onClick={() => {
              if (isOpen) {
                close()
              } else {
                fetchCreditBalance()
                open()
              }
            }}
            id={this.nodeId}
          >
            {renderLinkComponent({ isOpen })}
          </div>
        )}
      </PopoverMenu>
    )
  }
}
WalletPopoverMenu.defaultProps = {
  isToRight: false,
}

WalletPopoverMenu.propTypes = {
  t: PropTypes.func.isRequired,
  fetchNews: PropTypes.func.isRequired,
  news: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  hostConf: PropTypes.object.isRequired,
  renderLinkComponent: PropTypes.func.isRequired,
  isToRight: PropTypes.bool,
}

const enhance = compose(
  withTranslation(),
  connect(
    ({ app, orders }) => ({
      hostConf: app.hostConf,
      creditBalance: orders.creditBalance,
      creditCurrency: app.viewer.creditCurrency,
      isCreditBalanceLoading: orders.isCreditBalanceLoading,
    }),
    {
      fetchCreditBalance,
    },
  ),
)

export default enhance(WalletPopoverMenu)
